module.exports = __webpack_public_path__ + "img/szhxNo3_1.8f5437c3.png";